.button {
  width: 100%;
}

.icon {
  position: relative;
  top: -1px;
  margin-right: 0.5rem;
}

.buttonGroup {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 100%;
  padding: 0.5rem;
  background-color: var(--dropdown-background);
  border-color: var(--dropdown-border-color);

  @media (--sm-up) {
    flex-direction: row;
  }

  .dropdown-toggle::after {
    display: none;
  }
}

.inner {
  position: relative;
}
